'use client';
import React, { ButtonHTMLAttributes, FC, useEffect, useState } from 'react';
import { useFormStatus } from 'react-dom'
import LoaderComponent from './loader-component';

interface Props {
  label?: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  wFull?: boolean;
  hidden?: boolean;
  styles?: string;
  formAction?: ButtonHTMLAttributes<HTMLButtonElement>['formAction'];
}

const ButtonComponent: FC<Props> = ({
  label,
  type = 'button',
  onClick,
  hidden = false,
  wFull = false,
  styles,
  formAction,
}) => {
  const { pending } = useFormStatus()
  const [isWFull, setIsWFull] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [className, setClassName] = useState('');

  useEffect(() => {
    setIsWFull(wFull);
    setIsHidden(hidden);
    classNameBuilder();
  }, [className, hidden, wFull]);

  const classNameBuilder = () => {
    let classNameBase =
      'bg-amber-400 px-4 py-2 rounded-lg font-bold text-neutral-800 uppercase hover:bg-amber-500 print:hidden';

    if (isWFull) {
      classNameBase += ' w-full';
    }

    if (isHidden) {
      classNameBase += ' hidden';
    }

    if (styles) {
      classNameBase += styles;
    }

    setClassName(classNameBase);
  };

  return (
    <button className={className} type={type} onClick={onClick} formAction={formAction} disabled={pending}>
      {pending ? <LoaderComponent /> : label}
    </button>
  );
};

export default ButtonComponent;
